import React from "react";
import FilterFieldSelection from "./FilterFieldSelection";
import { useFilterBuilderContext } from "./FilterBuilderContext";
import "./FilterBuilder.scss";
import FilterDetailsForm from "./FilterDetailsForm/FilterDetailsForm";

const FilterBuilder: React.FC = () => {
  const {
    filterBuilderState: { currentFilterField },
  } = useFilterBuilderContext();

  return (
    <div className={"filter-builder"} data-testid={"filter-builder"}>
      {!currentFilterField ? (
        <div className={"filter-field-selection-wrapper"}>
          <FilterFieldSelection />
        </div>
      ) : (
        <div className={"filter-details-selection-wrapper"}>
          <FilterDetailsForm />
        </div>
      )}
    </div>
  );
};

export default FilterBuilder;
